import {ReactNode} from "react";
import {Button, Modal, Spinner} from "react-bootstrap";

interface Props {
    show: boolean;
    title: string;
    children: ReactNode;
    confirmLabel: string;
    variant?: string;
    busy?: boolean;
    onConfirm(): void;
    onCancel(): void;
}

export function ConfirmModal({show, title, children, confirmLabel, variant = 'danger', busy, onConfirm, onCancel}: Props) {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel} disabled={busy}>Cancel</Button>
                <Button variant={variant} onClick={onConfirm} disabled={busy}>
                    {busy && <Spinner size="sm" className="me-2"/>}{confirmLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
